module.exports = __webpack_public_path__ + "img/bg2.6495c0a1.png";